import { type VariantProps, cva } from "class-variance-authority";

export { default as Button } from "./Button.vue";

export const buttonVariants = cva("inline-flex items-center justify-center whitespace-nowrap rounded-lg text-sm transition-colors disabled:pointer-events-none disabled:opacity-50", {
  variants: {
    variant: {
      default: "focus text-white bg-gray-800 border hover:bg-gray-700 active:bg-gray-700 focus:border-gray-800",
      accent: "focus rounded-sm skin-button uppercase tracking-wide text-xs border",
      destructive: "focus bg-red-500 text-gray-50 hover:bg-red-500/90 dark:bg-red-900 dark:text-gray-50 dark:hover:bg-red-900/90",
      outline: "focus bg-gray-100 dark:bg-input/30 hover:bg-gray-100 hover:text-gray-900 dark:border-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-50",
      secondary: "data-[active=true]:bg-blue-50 data-[active=true]:border-blue-500 focus text-gray-900 bg-white shadow-xs border border-input  hover:bg-gray-50 active:bg-gray-100 active:border-gray-300 dark:bg-gray-900 dark:text-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-50 dark:focus:bg-gray-800 dark:focus:text-gray-50 dark:focus:border-gray-800",
      ghost: "focus",
      link: "text-gray-900 underline-offset-4 hover:underline dark:text-gray-50",
    },
    size: {
      default: "h-9 px-4",
      sm: "h-7 px-2 py-0 text-xs",
      lg: "h-11 px-8",
      icon: "h-9 w-9",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});

export type ButtonVariants = VariantProps<typeof buttonVariants>;
